import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { MangoCoreModule } from '@mango/core';
import { MaterialModule } from '../modules/material.module';
import { EnumPipe } from './pipes/enum-pipe';
import { ItemTileComponent } from './components/item-tile/itemtile.component';
import { SubcollectionComponent } from './components/subcollection/subcollection.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { FlexLayoutModule } from '@angular/flex-layout';
import { JwtModule, AuthGuardModule, AuthenticationModule } from '@mango/authentication';
import { AuthorizationModule } from '@mango/authorization';
import { UserCollectionComponent } from '../user/user-collection.component';
import { UserFilterComponent } from '../user/user-filter.component';
import { RouterModule } from '@angular/router';
import { BaseLayoutComponent } from './components/base-layout/base-layout.component';
import { AlertsPopupComponent } from './components/alert-popup/alert-popup.component';
import { componentsExtra } from '../components-extra';
import { components } from '../components';
import { AdresCollectionComponent } from '../cij/adres/adres/adres-collection.component';
import { ContactpersoonCollectionComponent } from '../cij/contactpersoon/contactpersoon/contactpersoon-collection.component';
import { ConditieCollectionComponent } from '../cij/conditie/conditie/conditie-collection.component';
import { ArtikelLeverancierCollectionComponent } from '../cij/artikel-leverancier/artikel-leverancier/artikel-leverancier-collection.component';
import { ArtikelLeverancierPrijzenCollectionComponent } from '../cij/artikel-leverancier-prijs/artikel-leverancier-prijzen/artikel-leverancier-prijzen-collection.component';
import { VerzendTarievenPrijzenCollectionComponent } from '../cij/verzend-tarieven-prijzen/verzend-tarieven-prijzen/verzend-tarieven-prijzen-collection.component';
import { ArtikelVerkoopPrijzenCollectionComponent } from '../cij/artikel-verkoop-prijzen/artikel-verkoop-prijzen/artikel-verkoop-prijzen-collection.component';
import { MerkCollectionComponent } from '../cij/merk/merk/merk-collection.component';
import { SoortCollectionComponent } from '../cij/soort/soort/soort-collection.component';
import { SoortTempCollectionComponent } from '../cij/soort-temp/soort-temp/soort-temp-collection.component';
import { InstrumentPrijsHistorieCollectionComponent } from '../cij/instrument-prijs-historie/instrument-prijs-historie/instrument-prijs-historie-collection.component';
import { InstrumentDefinitieCollectionComponent } from '../cij/instrument-definitie/instrument-definitie/instrument-definitie-collection.component';
import { InstrumentCollectionComponent } from '../cij/instrument/instrument/instrument-collection.component';
import { ProjectregelCollectionComponent } from '../cij/projectregel/projectregel/projectregel-collection.component';
import { ProjectCollectionComponent } from '../cij/project/project/project-collection.component';
import { ProjectregelArtikelCollectionComponent } from '../cij/projectregel-artikel/projectregel-artikel/projectregel-artikel-collection.component';
import { ReportingModule } from '@mango/reporting';
import { MailService } from '../core/service/mail.service';
import { ProjectregelStatusHistorieCollectionComponent } from '../cij/projectregel-status-historie/projectregel-status-historie/projectregel-status-historie-collection.component';
import { OproepHistorieCollectionComponent } from '../cij/oproep-historie/oproep-historie/oproep-historie-collection.component';
import { PakbonCollectionComponent } from '../cij/pakbon/pakbon/pakbon-collection.component';
import { PakbonregelCollectionComponent } from '../cij/pakbonregel/pakbonregel/pakbonregel-collection.component';
import { FactuurCollectionComponent } from '../cij/factuur/factuur/factuur-collection.component';
import { FactuurregelCollectionComponent } from '../cij/factuurregel/factuurregel/factuurregel-collection.component';
import { FacturerenCollectionComponent } from '../cij/pakbon/pakbon/factureren-collection.component';
import { kpCertificaatCollectionComponent } from '../cij/kp-certificaat/kp-certificaat/kp-certificaat-collection.component';
import { RelatieUserCollectionComponent } from '../relatie-user/relatie-user/relatie-user-collection.component';
import { UserLoginHistoryCollectionComponent } from '../user/login-history-collection-component';
import { MatMomentDatetimeModule } from '@mat-datetimepicker/moment';
import { MatDatetimepickerModule } from '@mat-datetimepicker/core';
import { SendMailPopupComponent } from './components/sendmail-popup/sendmail-popup.component';
import { QuillModule } from 'ngx-quill';
import { FactuurStatusHistorieCollectionComponent } from '../cij/factuurStatusHistorie/factuurStatusHistorie/FactuurStatusHistorie-collection.component';
import { FactuurGoedkeurenCollectionComponent } from '../cij/factuur/factuur/factuur-goedkeuren-collection.component';
import { FactuurExporterenCollectionComponent } from '../cij/factuur/factuur/factuur-exporteren-collection.component';
import { LoadingDialogComponent } from './components/loading-dialog/loading-dialog.component';
import { MAT_DATE_LOCALE } from '@angular/material/core';

const sharedCollections = [
    AdresCollectionComponent, 
    ContactpersoonCollectionComponent,
    ConditieCollectionComponent,
    ArtikelLeverancierCollectionComponent,
    ArtikelLeverancierPrijzenCollectionComponent,
    VerzendTarievenPrijzenCollectionComponent,
    ArtikelVerkoopPrijzenCollectionComponent,
    MerkCollectionComponent,
    SoortCollectionComponent,
    SoortTempCollectionComponent,
    InstrumentPrijsHistorieCollectionComponent,
    InstrumentDefinitieCollectionComponent,
    InstrumentCollectionComponent,
    ProjectregelCollectionComponent,
    ProjectCollectionComponent,
    ProjectregelArtikelCollectionComponent,
    ProjectregelStatusHistorieCollectionComponent,
    OproepHistorieCollectionComponent,
    PakbonCollectionComponent,
    FacturerenCollectionComponent,
    PakbonregelCollectionComponent,
    FactuurCollectionComponent,
    FactuurGoedkeurenCollectionComponent,
    FactuurExporterenCollectionComponent,
    FactuurregelCollectionComponent,
    kpCertificaatCollectionComponent,
    RelatieUserCollectionComponent,
    UserLoginHistoryCollectionComponent,
    FactuurStatusHistorieCollectionComponent
]

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MangoCoreModule.forRoot(),
        MaterialModule,
        HttpClientModule,
        FlexLayoutModule,
        JwtModule,
        AuthGuardModule,
        AuthenticationModule,
        RouterModule,
        ReportingModule,
        AuthorizationModule.forRoot({ UserCollectionComponent: UserCollectionComponent, UserFilterComponent: UserFilterComponent, userDetailRouterLink: '/users/detail' }),
        MatMomentDatetimeModule,
        MatDatetimepickerModule,
        QuillModule.forRoot(),
    ],
    declarations: [
        ItemTileComponent,
        SubcollectionComponent,
        BaseLayoutComponent,
        AlertsPopupComponent,
        SendMailPopupComponent,
        LoadingDialogComponent,
        EnumPipe,
        componentsExtra,

        sharedCollections,
        components 
    ],
    providers: [
        { provide: MAT_DATE_LOCALE, useValue: 'nl-NL' },
        DatePipe,
        MailService        
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MangoCoreModule,
        MaterialModule,
        ItemTileComponent,
        SubcollectionComponent,
        RouterModule,
        
        HttpClientModule,
        FlexLayoutModule,
        JwtModule,
        AuthGuardModule,
        AuthenticationModule,
        AuthorizationModule,
        AlertsPopupComponent,
        SendMailPopupComponent,
        LoadingDialogComponent,
        EnumPipe,
        componentsExtra,

        sharedCollections,

        //*********************************************************/
        components //TODO: Move all from this into separate modules!
        //*********************************************************/
    ]
})
export class SharedModule { }
